import http from '../../utils/fetch';
export default {
    //项目列表
    selectProject(value){
        return http({
            url: '/api/swyl/v1/mubiao/userDailyTargetProject/selectTargetProjcetPage',
            method: 'post',
            params:value
        });
    },
    deleteId(id) {
        return http({
            url: '/api/swyl/v1/mubiao/userDailyTargetProject/deleteOrBan?id='+id,
            method: 'post',
        });
    },
    banProject(id) {
        return http({
            url: '/api/swyl/v1/mubiao/userDailyTargetProject/banProject?id='+id,
            method: 'post',
        });
    },
}